import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeEnd extends Shape {
    width = 200;
    height = 200;
    defaultColor = "#000000";

    setDrawStyle(_: any): void {}

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 2) / 3 - 2 * horizontalPadding;
        const allowedHeight = (height * 2) / 3 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, height, height / 5, null);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(
        x: number,
        y: number,
        w: number,
        h: number,
        shapeStyles: {
            color: string;
            borderColor: string;
            borderDashType: string;
            borderWidth: number;
        },
    ) {
        const k = 15.5 / 22;
        canv.ctx.save();
        canv.ctx.fillStyle = shapeStyles.color;
        canv.ctx.strokeStyle = shapeStyles.color;
        canv.ctx.lineWidth = shapeStyles.borderWidth;
        canv.ctx.beginPath();
        canv.ctx.ellipse(x + w / 2, y + h / 2, h / 2, w / 2, Math.PI / 2, 0, 2 * Math.PI);
        canv.ctx.stroke();
        canv.ctx.closePath();

        canv.ctx.beginPath();
        canv.ctx.ellipse(
            x + w / 2,
            y + h / 2,
            (h * k) / 2,
            (w * k) / 2,
            Math.PI / 2,
            0,
            2 * Math.PI,
        );
        canv.ctx.fill();
        canv.ctx.closePath();
        canv.ctx.restore();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "black";
        let stroke = "";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "#7C7C91";
            stroke = "";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <g fill="${fill}" stroke="${stroke}">
                    <path d="m12 4.31682c4.2431.0001 7.6832 3.44003 7.6832 7.68318-.0001 4.2431-3.4401 7.6831-7.6832 7.6832-4.24315 0-7.68308-3.4401-7.68318-7.6832 0-4.24321 3.43997-7.68318 7.68318-7.68318z"/>
                    <path clip-rule="evenodd" d="m12 1c6.0751 0 11 4.92487 11 11 0 6.0751-4.9249 11-11 11-6.07513 0-11-4.9249-11-11 0-6.07513 4.92487-11 11-11zm0 1.40426c-5.29958 0-9.59574 4.29616-9.59574 9.59574 0 5.2996 4.29616 9.5957 9.59574 9.5957 5.2996 0 9.5957-4.2961 9.5957-9.5957 0-5.29958-4.2961-9.59574-9.5957-9.59574z"
                    fill-rule="evenodd"/>
                </g>
            </svg>
        `;
    }
}
